import type { ListParams } from 'types/api'
import type { VenueEvent } from 'types/model'

import { isoToUTC } from '@utils/date-time'

/**
 * Params for listing venue events on exactly one diary day (matches inventory list API shape).
 * Without `dateEnd`, `venueApi.listEvents` defaults `dateEnd` to +30 days, so the API would
 * return the earliest upcoming event in that window — wrong for “event on this browse day”.
 */
export function buildVenueDayEventListParams(
  date: string
): Pick<ListParams<VenueEvent>, 'limit' | 'skip' | 'sort' | 'dateStart' | 'dateEnd'> {
  const diaryMs = isoToUTC(date, { startOfDay: true })
  const dayParam = diaryMs != null ? diaryMs.toString() : date

  return {
    limit: 1,
    skip: 0,
    sort: 'dateStart',
    dateStart: dayParam,
    dateEnd: dayParam,
  }
}
